export const charleyMemoryConfig = {
  routePath: '/charley-memory',
  // NOTE: guestbook + events have been migrated to Firestore and no longer use apiBaseUrl.
  // apiBaseUrl is kept for remaining Zeabur-backed functions (todos, auth/records, fetchEvents).
  // Zeabur backend is currently down — those functions will fail until Zeabur is restored or migrated.
  apiBaseUrl:
    process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_CHARLEY_MEMORY_API_BASE_URL_LOCAL || 'http://localhost:8080'
      : process.env.REACT_APP_CHARLEY_MEMORY_API_BASE_URL || 'https://charley-memory.zeabur.app',
};
